import BaseService, { IHttpResponse } from '../../../BaseService';
import TokensService from '../../../TokensService/TokensService';
import { IPrepareMediaPlaysUrl, prepareMediaPlaysUrl } from '../BuildUrls';
import { IMediaPlays } from '../Types';

const debug = require('debug')(
  'tca:service:MediaPersonalizationService:MediaPlayService:Core:Update'
);

export enum MEDIA_FORMAT {
  AUDIO = 'audio',
  VIDEO = 'video',
}

export interface IMediaPlayUpdateBody {
  app_key: string;
  duration_ms?: number;
  last_media_format?: MEDIA_FORMAT;
  play_count?: number;
  progress_ms?: number /** progress has be rounded to the full integer. Decimals will return 400. */;
  _embedded: {
    'media-item': {
      id: string;
    };
    'end-user': {
      id: string;
    };
  };
}

interface IMediaPlaysUpdate extends IPrepareMediaPlaysUrl {
  appKey: string;
  data: IMediaPlayUpdateBody;
}

interface IMediaPlaysUpdateResponse extends IHttpResponse {
  body?: IMediaPlays;
}

export default async function Update({
  appKey,
  data,
  ...buildUrlProps
}: IMediaPlaysUpdate): Promise<IMediaPlaysUpdateResponse> {
  debug('Update');
  const token = (await TokensService.getGuestToken()) || '';
  const url = prepareMediaPlaysUrl(buildUrlProps);

  return BaseService.Patch({
    appKey,
    url,
    token,
    data,
  });
}
